import { initModalListeners } from "./auth/authModals"
import { initCitySearch } from "./cityChoise/citySearch"
import { appointmentFormRules, callFormRules } from './formRules/formController'
import { setCookie, eraseCookie, getCookie, cityIdentityCookieDays } from "./cityChoise/cookie"
import { toDateInputValue } from './utils/common'
import { initSearch } from "./search"

const RECAPTCHA_SITE_KEY = '6LctEsogAAAAABaBNK6GZj8y3T25tm-lkd2AGWdw';

$(document).ready(function () {
    initModalListeners()
    initSearch()

    const citiesBlockHtml = $(".cities-list").html()
    const dialogWindow = $(".city-choise-dialog");
    let citiesModal = null

    $(".choose-city-btn").on("click", function (event) {
        event.preventDefault();
        const wrappedHtml = `
        <div class="cities-modal modal-classic modal-area">
            ${App.components.Modal.closeHtml}
            ${citiesBlockHtml}
        </div>
        `;
        citiesModal = new App.components.Modal("citiesModal", wrappedHtml);
        citiesModal.show();

        initCitySearch()
        // Теперь элементы с .js-change-city появятся в DOM, и можно установить обработчик
        $('#citiesModal').on('click', '.js-change-city', function (event) {
            event.preventDefault();
            const cityName = $(this).text().trim();
            const id = $(this).data('id');
            const redirectUrl = $(this).attr('href');
            //$('.js-form-city').val(cityName);
            eraseCookie("currentCityId")
            if (!$(this).data('subdomain')) {
                setCookie("currentCityId", id, cityIdentityCookieDays);
            }

            citiesModal.close();
            window.location.href = redirectUrl;
        });
    });

    const currentCityId = getCookie("currentCityId");

    if (currentCityId) {
        dialogWindow.hide();
    } else {
        dialogWindow.show();
    }

    $(".js-set-current-city").on("click", function(event) {
        event.preventDefault();
        
        const id = dialogWindow.data("city-id");
        
        setCookie("currentCityId", id, cityIdentityCookieDays);
        dialogWindow.hide();
    })

    $(".js-popup-handler").on("click", function (event) {
        event.preventDefault();

        switch ($(this).data('action')) {
            case 'appointment':
                fetch(`/local/ajax/getAppointmentModal.php`)
                    .then(response => response.text())
                    .then(html => {
                        const modal = new App.components.Modal("appointmentModal", html);
                        const formElement = $(modal.modalElement).find("form[name='APPOINTMENT_FORM']");
                        const dateInput = $(modal.modalElement).find("input[type='date']")
                        const phoneInput = $(modal.modalElement).find("#APPOINTMENT_6")

                        phoneInput.mask("+7 999 999-99-99");
                        phoneInput.attr("placeholder", "+7")

                        dateInput.val(toDateInputValue(new Date()));
                        dateInput.attr("min", toDateInputValue(new Date()));

                        $(modal.modalElement).find(".salons-select").select2({
                            language: "ru",
                            width: '100%',
                            minimumResultsForSearch: -1
                        });

                        if ($('#g-recaptcha-modal').length) {
                            grecaptcha.render('g-recaptcha-modal', {
                                'sitekey': RECAPTCHA_SITE_KEY
                            });
                        }

                        formElement.validate(appointmentFormRules);

                        modal.show();
                    });
                break;
            case 'call':
                fetch(`/local/ajax/getCallModal.php`)
                    .then(response => response.text())
                    .then(html => {
                        const modal = new App.components.Modal("appointmentModal", html);
                        const formElement = $(modal.modalElement).find("form[name='CALL_FORM']");
                        const phoneInput = formElement.find("#CALL_9")

                        phoneInput.mask("+7 999 999-99-99");
                        phoneInput.attr("placeholder", "+7")

                        if ($('#g-recaptcha-modal').length) {
                            grecaptcha.render('g-recaptcha-modal', {
                                'sitekey': RECAPTCHA_SITE_KEY
                            });
                        }

                        formElement.validate(callFormRules);

                        modal.show();
                    });
                break;

            default:
                break;
        }
    });

    $('.dropdown-btn').click(function () {
        $(this).toggleClass('active');
    })
});
